import React, { lazy, useEffect, useState } from 'react';
import "./LinesContainer.scss";
import humanOutline from '../../../common/icons/svg/human-outline.png';
import ImageMapper from 'react-img-mapper';
import TimePicker from 'react-time-picker';
import CustomSelect from '../../CustomSelect/CustomSelect';
import { createLines, getLines, updateLines } from '../../../helper/chart-helper';
import { LINES_ACTIONS, LINES_DROPDOWN_OPTIONS } from '../../../common/constant/common-constants';
import moment from 'moment';
import { checkIfBedIdContainsSession } from '../../../common/utils/CommonUtils';

function LinesContainer(props) {

    const [areas, setAreas] = useState([]);
    const [xcoord, setXcoord] = useState();
    const [ycoord, setYcoord] = useState();
    const [linesInputState, setLinesInputState] = useState([]);
    const [linesDataFromGetAPI, setLinesDataFromGetAPI] = useState([]);
    const [showContinueDialog, setShowContinueDialog] = useState("");
    const [removeActive, setRemoveActive] = useState("");

    useEffect(() => {
        getLinesHandler();
    }, [])

    useEffect(() => {
        getLinesHandler();
    }, [props.data.prescriptionDate])

    const getLinesHandler = () => {
        let data = {
            bedId: checkIfBedIdContainsSession(props.data.bedId),
            patientSessionId: props.data.patientSessionId,
            date: moment(props.data.prescriptionDate).format("YYYY-MM-DD"),
        }
        getLines(data).then((res) => {
            console.log("res of linesAPI", res);
            let lines = res.lines.sort((a, b) => parseInt(a.id) - parseInt(b.id));
            setLinesDataFromGetAPI(lines);
            setLinesInputState(lines);
            handleAreasOnGet(lines);

        }).catch((err) => {
            console.log("error occured in get API of Lines", err)
        })
    }
    const handleAreasOnGet = (linesArr) => {
        const tempAreas = linesArr.map((ele) => {
            return {
                id: ele.id,
                name: ele.id,
                shape: "circle",
                coords: [parseInt(ele.xCordinate), parseInt(ele.yCordinate), 6],
                preFillColor: 'red',
            }
        })
        // console.log("tempAreas", tempAreas);
        setAreas([...tempAreas]);
    }

    const updateLinesHandler = (lineInfo) => {
        let data = {
            bedId: props.data.bedId,
            patientSessionId: props.data.patientSessionId,
            date: moment(props.data.prescriptionDate).format("YYYY-MM-DD"),
            id: lineInfo.lineId,
            action: lineInfo.action,
            removalRemarks: lineInfo.removalRemarks,
            removalTime: lineInfo.removalTime,
        }
        // console.log('data for update', data);
        updateLines(data).then((res) => {
            getLinesHandler();

        }).catch((err) => {
            console.log("updation err", err);
        })
        props.setSubmitLines(false);
    }

    useEffect(() => {
        if (props.submitLines) {
            createLinesHandler();
        }
    }, [props.submitLines])

    const createLinesHandler = () => {
        // filter for only new lines to be sent for addition
        let dataForCreation;
        if (linesDataFromGetAPI.length > 0) {
            let tempLinesData = linesInputState.filter((ele) => {
                if (linesDataFromGetAPI.findIndex((existingLine) => existingLine.id === ele.id) === -1)
                    return ele
            })

            dataForCreation = tempLinesData
            // console.log("tempLinesDAta", tempLinesData);
        } else {
            dataForCreation = linesInputState
        }
        // this filter is for when user has not entered any field in the input 
        // then that line should not go for creation.
        dataForCreation = dataForCreation.filter((ele) => ele.id && ele.siteLocation && ele.size && ele.type && ele.insertionTime)

        // console.log("data for creation", dataForCreation);
        let data = {
            bedId: props.data.bedId,
            patientSessionId: props.data.patientSessionId,
            date: moment(props.data.prescriptionDate).format("YYYY-MM-DD"),
            data: dataForCreation,
        }
        createLines(data).then((res) => {
            // console.log("created lines", res)
            getLinesHandler();

        }).catch((err) => {
            console.log(err);
        })
        props.setSubmitLines(false);
    }

    const handleImageClick = (event) => {
        if (!props.isEditable) return false;
        if (areas[areas.length - 1] && areas[areas.length - 1].coords[0] === (event.clientX - 100) ||
            areas[areas.length - 1] && areas[areas.length - 1].coords[1] === (event.clientY - 330)) {
            return false;
        }
        let count = areas.length + 1;
        setAreas([...areas,
        {
            id: `${count}`,
            name: `${count}`,
            shape: "circle",
            coords: [event.clientX - 100, event.clientY - 330, 6],
            preFillColor: 'red',
        }])
        setXcoord(event.clientX);
        setYcoord(event.clientY);

    }


    const handleCoordinates = (xCoordinate, yCoordinate) => {
        if (!props.isEditable) return false;
        let lineNumber = areas.length + 1;

        setLinesInputState([...linesInputState, {
            id: lineNumber,
            xCordinate: xCoordinate,
            yCordinate: yCoordinate,
        }])
    }

    const handleChangeState = (val, lineNumber, inputName) => {
        let tempData = linesInputState;
        let idx = tempData.findIndex((ele) => parseInt(ele.id) === parseInt(lineNumber));
        console.log("index of", idx);
        let tempDataObj = tempData[idx];
        tempDataObj[inputName] = val;
        tempData[idx] = tempDataObj;
        setLinesInputState(tempData);
    }

    const handleSiteLocation = (event, lineNumber) => {
        // console.log("SITE-LOCATION--event", event, 'lineNumber', lineNumber);
        handleChangeState(event.target.value, lineNumber, 'siteLocation');
    }

    const handleType = (item, lineNumber) => {
        // console.log("TYPE--event", item, 'lineNumber', lineNumber);
        handleChangeState(item.label, lineNumber, 'type');
    }

    const handleSize = (event, lineNumber) => {
        // console.log("SIZE--event", event, 'lineNumber', lineNumber);
        handleChangeState(event.target.value, lineNumber, 'size');
    }

    const handleInsertionTime = (time, lineNumber) => {
        // console.log("INSERTION-TIME--event", time, 'lineNumber', lineNumber);
        handleChangeState(time, lineNumber, 'insertionTime');
    }
    const handleContinueConfirm = (lineId) => {
        let updateData = {
            lineId: lineId,
            action: LINES_ACTIONS.CONTINUE,
            removalRemarks: "",
            removalTime: "",
        }

        updateLinesHandler(updateData);
        setShowContinueDialog("");
    }
    const handleRemoveSave = (lineId) => {
        let tempObj = linesInputState.filter((ele) => ele.id === lineId)[0];
        let updateData = {
            lineId: lineId,
            action: LINES_ACTIONS.REMOVE,
            removalRemarks: tempObj.removalRemarks,
            removalTime: tempObj.removalTime,
        }
        updateLinesHandler(updateData);
        setRemoveActive("")
    }

    const handleRemovalTime = (time, lineNumber) => {
        // console.log("REMOVAL_TIME--event", time, 'lineNumber', lineNumber);
        handleChangeState(time, lineNumber, 'removalTime');
    }

    const handleRemoveRemark = (event, lineNumber) => {
        console.log("REMOVAL_REMARK--event", event.target.value, 'lineNumber', lineNumber);
        handleChangeState(event.target.value, lineNumber, 'removalRemarks');
    }

    return (
        <div className='lines-container'>
            <div className='body-panels'>
                <div className='left-panel' id='left-panel-id'>
                    <ImageMapper src={humanOutline}
                        map={{ name: 'my-map', areas: areas }}
                        height={document.getElementById("left-panel-id") && document.getElementById("left-panel-id").clientHeight}
                        width={document.getElementById("left-panel-id") && document.getElementById("left-panel-id").clientWidth}
                        onImageClick={event => {
                            handleImageClick(event);
                            handleCoordinates(event.clientX - 100, event.clientY - 335)
                        }}
                        active={props.isEditable}
                        // natural={true}
                        // rerenderProps={[]}
                        // areaKeyName={true}
                        stayHighlighted={true}
                    // onImageMouseMove={evt => console.log("mouse move event", evt)}
                    />
                </div>
                <div className='right-panel'>
                    {(linesInputState && linesInputState.length == 0) && <div className='no-points-selected-text'>Click on where the line is to be inserted on the human figure</div>}
                    {linesInputState && linesInputState.length > 0 && linesInputState.map((line) => {
                        return (
                            (linesDataFromGetAPI.findIndex((ele) => ele.id === line.id) === -1) ?
                                <div className='lines-info-container' key={line.id}>
                                    <span className='line-number'>Line {line.id}</span>
                                    <div className='input-container'>
                                        <div className="site-location-container">
                                            <label>Site Location</label>
                                            <input
                                                className="size-input"
                                                placeholder="Specify the site location"
                                                onChange={(event) => handleSiteLocation(event, line.id)}
                                            />
                                        </div>
                                        <div className="type-input-container">
                                            <label className="">Type</label>
                                            <CustomSelect
                                                className="type-select"
                                                handleChange={(item) => handleType(item, line.id)}
                                                label='interval'
                                                options={LINES_DROPDOWN_OPTIONS}
                                                placeholder="Type"
                                                components={{
                                                    IndicatorSeparator: () => null
                                                }}
                                            />
                                        </div>
                                        <div className="size-input-container">
                                            <label>Size</label>
                                            <input
                                                className="size-input"
                                                placeholder="Specify size"
                                                onChange={(event) => handleSize(event, line.id)}
                                            />
                                        </div>
                                        <div className="insertion-time-container">
                                            <label className="time label">Insertion Time</label>
                                            <TimePicker
                                                className="insertion-time"
                                                onChange={(time) => handleInsertionTime(time, line.id)}
                                            />
                                        </div>

                                    </div>
                                </div>
                                :
                                <div className={`line-info-filled-container ${line.status === LINES_ACTIONS.REMOVE ? 'removed-container' : ""}`} key={line.id}>
                                    {(showContinueDialog === line.id) &&
                                        <div className='continue-dialog-container'>
                                            <div className='header-cont'>Continue ?</div>
                                            <div className='text-continue'>Are you sure you want to continue the line?</div>
                                            <div className='continue-btn-container'>
                                                <div className='common-cont-btn cancel-cont' onClick={() => setShowContinueDialog("")}>
                                                    Cancel
                                                </div>
                                                <div className='common-cont-btn confirm-cont' onClick={() => handleContinueConfirm(line.id)}>
                                                    Confirm
                                                </div>
                                            </div>
                                        </div>}
                                    <div className='input-header'>
                                        <div className='line-number'>Line {line.id}</div>
                                        {line.status !== LINES_ACTIONS.REMOVE && (removeActive === line.id ?
                                            <div className='btn-container'>
                                                <div className='common-btn remove-cancel-btn' onClick={() => setRemoveActive("")}>
                                                    Cancel
                                                </div>
                                                <div className='common-btn remove-save-btn' onClick={() => handleRemoveSave(line.id)}>
                                                    Save
                                                </div>
                                            </div>
                                            :
                                            <div className='btn-container'>
                                                {line.status !== LINES_ACTIONS.CONTINUE && <div className='common-btn continue-btn' onClick={() => setShowContinueDialog(line.id)}>
                                                    Continue
                                                </div>}
                                                <div className='common-btn remove-btn' onClick={() => setRemoveActive(line.id)}>
                                                    Remove
                                                </div>
                                            </div>)}
                                    </div>
                                    <div className='input-filled-container'>
                                        <div className="common-input-filled">
                                            <label>Site Location</label>
                                            <input
                                                className="size-input"
                                                placeholder="Specify the site location"
                                                value={linesDataFromGetAPI &&
                                                    linesDataFromGetAPI.findIndex((ele) => parseInt(ele.id) === parseInt(line.id)) !== -1 ?
                                                    linesDataFromGetAPI[linesDataFromGetAPI.findIndex((ele) => parseInt(ele.id) === parseInt(line.id))].siteLocation ?
                                                        linesDataFromGetAPI[linesDataFromGetAPI.findIndex((ele) => parseInt(ele.id) === parseInt(line.id))].siteLocation : ""
                                                    : ""}
                                                onChange={(event) => handleSiteLocation(event, line.id)}
                                                disabled={true}
                                            />
                                        </div>
                                        <div className="common-input-filled">
                                            <label>Type</label>
                                            <input
                                                className="type-input"
                                                placeholder="Specify type"
                                                value={linesDataFromGetAPI &&
                                                    linesDataFromGetAPI.findIndex((ele) => parseInt(ele.id) === parseInt(line.id)) !== -1 ?
                                                    linesDataFromGetAPI[linesDataFromGetAPI.findIndex((ele) => parseInt(ele.id) === parseInt(line.id))].type ?
                                                        linesDataFromGetAPI[linesDataFromGetAPI.findIndex((ele) => parseInt(ele.id) === parseInt(line.id))].type : ""
                                                    : ""}
                                                onChange={(event) => handleType(event, line.id)}
                                                disabled={true}
                                            />
                                        </div>
                                        <div className="common-input-filled">
                                            <label>Size</label>
                                            <input
                                                className="size-input"
                                                placeholder="Specify size"
                                                value={linesDataFromGetAPI &&
                                                    linesDataFromGetAPI.findIndex((ele) => parseInt(ele.id) === parseInt(line.id)) !== -1 ?
                                                    linesDataFromGetAPI[linesDataFromGetAPI.findIndex((ele) => parseInt(ele.id) === parseInt(line.id))].size ?
                                                        linesDataFromGetAPI[linesDataFromGetAPI.findIndex((ele) => parseInt(ele.id) === parseInt(line.id))].size : ""
                                                    : ""}
                                                onChange={(event) => handleSize(event, line.id)}
                                                disabled={true}
                                            />
                                        </div>
                                        <div className="common-input-filled">
                                            <label>Insertion Time</label>
                                            <input
                                                className="time-input"
                                                placeholder="Time"
                                                value={linesDataFromGetAPI &&
                                                    linesDataFromGetAPI.findIndex((ele) => parseInt(ele.id) === parseInt(line.id)) !== -1 ?
                                                    linesDataFromGetAPI[linesDataFromGetAPI.findIndex((ele) => parseInt(ele.id) === parseInt(line.id))].insertionTime ?
                                                        linesDataFromGetAPI[linesDataFromGetAPI.findIndex((ele) => parseInt(ele.id) === parseInt(line.id))].insertionTime : ""
                                                    : ""}
                                                onChange={(event) => handleInsertionTime(event, line.id)}
                                                disabled={true}
                                            />
                                        </div>
                                        {line.status === LINES_ACTIONS.REMOVE &&
                                            <>
                                                <div className="common-input-filled">
                                                    <label>Removal Time</label>
                                                    <input
                                                        className="time-input"
                                                        value={linesDataFromGetAPI &&
                                                            linesDataFromGetAPI.findIndex((ele) => parseInt(ele.id) === parseInt(line.id)) !== -1 ?
                                                            linesDataFromGetAPI[linesDataFromGetAPI.findIndex((ele) => parseInt(ele.id) === parseInt(line.id))].removalTime ?
                                                                linesDataFromGetAPI[linesDataFromGetAPI.findIndex((ele) => parseInt(ele.id) === parseInt(line.id))].removalTime : ""
                                                            : ""}
                                                        onChange={(event) => console.log(event)}
                                                        disabled={true}
                                                    />
                                                </div>
                                                <div className="common-input-filled removal-col">
                                                    <label>Removal Remark</label>
                                                    <input
                                                        className=""
                                                        value={linesDataFromGetAPI &&
                                                            linesDataFromGetAPI.findIndex((ele) => parseInt(ele.id) === parseInt(line.id)) !== -1 ?
                                                            linesDataFromGetAPI[linesDataFromGetAPI.findIndex((ele) => parseInt(ele.id) === parseInt(line.id))].removalRemarks ?
                                                                linesDataFromGetAPI[linesDataFromGetAPI.findIndex((ele) => parseInt(ele.id) === parseInt(line.id))].removalRemarks : ""
                                                            : ""}
                                                        onChange={(event) => console.log(event)}
                                                        disabled={true}
                                                    />
                                                </div>
                                            </>
                                        }
                                        {(removeActive === line.id) &&
                                            <>
                                                <div className="removal-time-container">
                                                    <label className="">Removal Time</label>
                                                    <TimePicker
                                                        className="removal-time"
                                                        placeholder="Enter removal time"
                                                        onChange={(time) => handleRemovalTime(time, line.id)}
                                                    />
                                                </div>
                                                <div className="removal-remark-container">
                                                    <label>Removal Remark</label>
                                                    <input
                                                        className="remove-input"
                                                        placeholder="Enter remark"
                                                        onChange={(event) => handleRemoveRemark(event, line.id)}
                                                    />
                                                </div>
                                            </>
                                        }
                                    </div>
                                </div>
                        )
                    })}
                </div>
            </div>
        </div >
    );
}

export default LinesContainer;